export default {
  computed: {
    typeOptions() {
      return {
        campaign: this.$t('EmailRows_Type_Campaign'),
        template: this.$t('EmailRows_Type_Template')
      }
    }
  },

  methods: {
    typeLabel(row) {
      return row.is_campaign_template
        ? this.$t('EmailRows_Type_Template')
        : this.$t('EmailRows_Type_Campaign')
    },

    canViewRow(row) {
      if (row.is_campaign_template) {
        return this.canEdit || this.$can('createProjectItem')
      }
      if (this.$isRole('content-partner')) {
        return false
      }
      return this.$can('viewProjectItem')
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/email-saved-rows/mixins/syncedRowTypeMixin.js